import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ClientLayoutComponent } from '../layout/client-layout/client-layout.component';
// import { HomeComponent } from './pages/home/home.component';
// import { AboutComponent } from './pages/about/about.component';
import { HomeComponent } from './pages/home/home.component';
import { AboutComponent } from './pages/about/about.component';
import { ProductComponent } from './pages/product/product.component';
import { ProductDetailComponent } from './pages/product/product-detail/product-detail.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginSessionResetGuard } from '../core/guards/login-session-reset.guard';

const routes: Routes = [
  {
    path: '',
    component: ClientLayoutComponent,
    children: [
      { path: 'login', component: LoginComponent, canActivate: [LoginSessionResetGuard] },
      { path: '', component: HomeComponent },
      {
        path: 'product', component: ProductComponent,
        children: [
          {
            path: ':slug',
            component: ProductDetailComponent
          }
        ]
      },
      { path: 'about', component: AboutComponent },
      // { path: 'certification', redirectTo: '/admin/certification', pathMatch: 'full' },
      // { path: 'preferences', redirectTo: '/admin/preferences', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientRoutingModule { }
